import React, { useContext, useEffect } from "react";
import { MapViewerContext } from "src/contexts/MapViewerContext";
import { fromLonLat } from "ol/proj";

import "ol/ol.css";
import "./Map.css";
//import ZoomControl from "./controllers/Zoom";

const MapContainer = ({ children }) => {
  const { map, setMapCenter, setMapZoom } = useContext(MapViewerContext); // Access map and context functions

  useEffect(() => {
    const ori = [102.5, 1]; // Set center coordinates of Indonesia
    const zoom = 6; // Set zoom level for Indonesia
    //const center = [93, -6];
    setMapCenter(fromLonLat(ori));
    setMapZoom(zoom);

    //animateZoomTo(map.getView(), zoom + 5, fromLonLat(center)); // Set zoom level for Indonesia
    map.setTarget("map-container"); // Set the target for the map

    map.getControls().forEach((control) => {
      //console.log(control);
      map.removeControl(control);
      //if (control instanceof Zoom) {
      // map.removeControl(control);
      //}
    });
    /*

    const windData = [
      { lon: 0, lat: 0, u: 10, v: 5 },
      { lon: 1, lat: 0, u: 10, v: 5 }, // Example data point
      { lon: 2, lat: 0, u: 10, v: 5 }, // Example data point
      { lon: 3, lat: 0, u: 10, v: 5 }, // Example data point
      { lon: 4, lat: 0, u: 10, v: 5 }, // Example data point
      // Add more data points as needed
    ];

    // Create features for wind data
    const features = windData.map((data) => {
      const [x, y] = fromLonLat([data.lon, data.lat]);
      const point = new Point([x, y]);
      const feature = new Feature(point);
      // Set wind speed and direction as properties for styling
      feature.setProperties({ u: data.u, v: data.v });
      return feature;
    });

    // Create vector source and layer for wind data
    const vectorSource = new VectorSource({
      features: features,
    });
    const vectorLayer = new VectorLayer({
      source: vectorSource,
      // Add your custom wind animation style here
    });

    map.addLayer(vectorLayer);
    */
    // Add custom zoom control
    //const zoomControl = new ZoomControl({ map });
    //map.addControl(zoomControl);
  }, [map, setMapCenter, setMapZoom]);

  // Function to animate zoom
  /*
  const animateZoomTo = (view, zoom, center) => {
    view.animate({
      center: center,
      zoom: zoom,
      duration: 1000, // Animation duration in milliseconds
    });
  };
  */
  return <div id="map-container">{children}</div>;
};

export default MapContainer;
